import { render, staticRenderFns } from "./IngredientItemStepDelete.vue?vue&type=template&id=1ce54b45&"
import script from "./IngredientItemStepDelete.vue?vue&type=script&lang=js&"
export * from "./IngredientItemStepDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports